import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/laser-id-card-icon.png'


const _hoisted_1 = { class: "dopa-section" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "content-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "ยืนยันตัวตน"),
  /*#__PURE__*/_createElementVNode("span", { class: "description" }, "กรอกข้อมูลเป็นภาษาไทยตรงตามบัตรประชาชน เพื่อตรวจสอบความเป็นเจ้าของบัญชี")
], -1)
const _hoisted_4 = { class: "content-dopa" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("วัน/เดือน/ปี พ.ศ. เกิดของคุณไม่ถูกต้อง")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("รหัสหลังบัตรของคุณไม่ถูกต้อง")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "laser-id-card-icon",
  src: _imports_0
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "ประกอบด้วยตัวอักษร ภาษาอังกฤษ 2 หลัก ตามด้วยตัวเลข 10 หลัก", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "content-notification" }
const _hoisted_11 = { class: "notification-snackbar" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "notification-info" }, "เพื่อยืนยันตัวตนเท่านั้น และไม่มีการเก็บบันทึก", -1)
const _hoisted_13 = { class: "footer" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("ยืนยัน")

export function render(_ctx, _cache) {
  const _component_q_input = _resolveComponent("q-input")
  const _component_q_icon = _resolveComponent("q-icon")
  const _component_q_checkbox = _resolveComponent("q-checkbox")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_form = _resolveComponent("q-form")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_q_form, {
      class: "dopa-form",
      greedy: "",
      onSubmit: _ctx.submitForm,
      onValidationError: _ctx.onValidationError
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_q_input, {
              class: "q-pt-sm q-pb-xs",
              outlined: "",
              modelValue: _ctx.model.first_name,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = $event => ((_ctx.model.first_name) = $event)),
                _cache[1] || (_cache[1] = (val) => _ctx.onChangeFirstName(val))
              ],
              ref: _ctx.refKeys[0],
              label: "ชื่อ (ภาษาไทย, ไม่มีคำนำหน้า)",
              "no-error-icon": "",
              clearable: "",
              onBlur: _ctx.onBlurFirstName,
              rules: [(val) => _ctx.isThaiLanguage(val)]
            }, null, 8, ["modelValue", "onBlur", "rules"]),
            _createVNode(_component_q_input, {
              class: "q-pt-sm q-pb-xs",
              outlined: "",
              modelValue: _ctx.model.last_name,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = $event => ((_ctx.model.last_name) = $event)),
                _cache[3] || (_cache[3] = (val) => _ctx.onChangeLastName(val))
              ],
              ref: _ctx.refKeys[1],
              label: "นามสกุล (ภาษาไทย)",
              "no-error-icon": "",
              clearable: "",
              onBlur: _ctx.onBlurLastName,
              rules: [(val) => _ctx.isThaiLanguage(val)]
            }, null, 8, ["modelValue", "onBlur", "rules"]),
            _createVNode(_component_q_input, {
              class: "q-pt-sm q-pb-xs",
              outlined: "",
              modelValue: _ctx.model.date_of_birth,
              "onUpdate:modelValue": [
                _cache[5] || (_cache[5] = $event => ((_ctx.model.date_of_birth) = $event)),
                _ctx.onUpdateDOB
              ],
              ref: _ctx.refKeys[2],
              label: "วัน/เดือน/ปี พ.ศ. เกิด",
              "no-error-icon": "",
              clearable: "",
              maxlength: "10",
              placeholder: "วว/ดด/ปปปป",
              onBlur: _ctx.validateDOB,
              error: _ctx.isRequiredDateOfBirth || _ctx.isShowMessageDateOfBirthFormat,
              "hide-bottom-space": _ctx.isShowMessageDateOfBirthFormat
            }, _createSlots({
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "info_outline",
                  onClick: _cache[4] || (_cache[4] = $event => (_ctx.onShowTooltipDateOfBirth(_ctx.refKeys[3])))
                }),
                _createElementVNode("span", {
                  class: _normalizeClass(['tooltip', {active: _ctx.isTooltipDateOfBirth}])
                }, "กรณีไม่มีข้อมูลใดบนบัตร ให้กรอก วัน:00 เดือน:00", 2)
              ]),
              _: 2
            }, [
              (!_ctx.isRequiredDateOfBirth && _ctx.isShowMessageDateOfBirthFormat)
                ? {
                    name: "error",
                    fn: _withCtx(() => [
                      _hoisted_5
                    ])
                  }
                : undefined
            ]), 1032, ["modelValue", "onBlur", "onUpdate:modelValue", "error", "hide-bottom-space"]),
            _createVNode(_component_q_input, {
              class: "q-pt-sm q-pb-xs",
              standout: "",
              modelValue: _ctx.model.national_id,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.model.national_id) = $event)),
              ref: _ctx.refKeys[3],
              label: "เลขบัตรประชาชน",
              readonly: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_q_input, {
              class: "q-pt-sm q-pb-xs",
              outlined: "",
              modelValue: _ctx.model.laser,
              "onUpdate:modelValue": [
                _cache[8] || (_cache[8] = $event => ((_ctx.model.laser) = $event)),
                _cache[10] || (_cache[10] = ($e) => { _ctx.onUpdateLaser($e, false) })
              ],
              ref: _ctx.refKeys[4],
              label: "รหัสหลังบัตรประชาชน",
              "no-error-icon": "",
              clearable: "",
              maxlength: "14",
              placeholder: "LT0-0000000-00",
              onBlur: _cache[9] || (_cache[9] = () => { _ctx.validateLaser(true) }),
              error: _ctx.isRequiredLaser || _ctx.isShowMessageLaserFormat,
              "hide-bottom-space": _ctx.isShowMessageLaserFormat
            }, _createSlots({
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "info_outline",
                  onClick: _cache[7] || (_cache[7] = $event => (_ctx.onShowTooltipLaser(_ctx.refKeys[3])))
                }),
                _createElementVNode("span", {
                  class: _normalizeClass(['tooltip', {active: _ctx.isTooltipLaser}])
                }, _hoisted_9, 2)
              ]),
              _: 2
            }, [
              (!_ctx.isRequiredLaser && _ctx.isShowMessageLaserFormat)
                ? {
                    name: "error",
                    fn: _withCtx(() => [
                      _hoisted_6
                    ])
                  }
                : undefined
            ]), 1032, ["modelValue", "error", "hide-bottom-space"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_q_icon, {
                class: "notification-icon",
                name: "verified_user"
              }),
              _hoisted_12
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_q_checkbox, {
            class: "q-pb-md",
            size: "sm",
            dense: "",
            modelValue: _ctx.model.update_profile,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.model.update_profile) = $event)),
            label: "อัปเดตโปรไฟล์ของฉันตามข้อมูลข้างต้นนี้"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_q_btn, {
            class: "btn",
            unelevated: "",
            type: "submit",
            disable: !_ctx.isSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["disable"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "onValidationError"])
  ]))
}